

import { PayloadAction, createSlice } from '@reduxjs/toolkit';

import { RolesUsuarioProps } from '../../interfaces/admin/UsuarioInterface';

export const defaultRoles: RolesUsuarioProps = {
    ModuloNuevoProceso:         false,
    ModuloBusqueda:             false,
    ModuloConsultas:            false,
    ModuloCatalogos:            false,
    RegistradorInformacion:     false,
    GeneradorAcuseRecibo:       false,
    EscaneadorDocumentos:       false,
    ConsultaTramitesRecibidos:  false,
    GeneradorListadoEntrega:    false,
};

export interface stateProps {
    nombres:                            string;
    apellidos:                          string;
    correoElectronico:                  string;
    token:                              string;
    administrador:                      boolean;
    restablecerContrasena:              boolean;
    sistemaTurnos:                       number;
    roles:                              RolesUsuarioProps;
}

const initialState: stateProps = {
    token: '',
    nombres: '', 
    apellidos: '', 
    correoElectronico: '', 
    sistemaTurnos: 0,
    administrador: false,
} as stateProps;

export const authSlice = createSlice({
    name: 'auth',
    initialState: initialState,
    reducers: {
        login: ( state, { payload } : PayloadAction<stateProps> ) => {
            state.token = payload.token;
            state.nombres = payload.nombres;
            state.apellidos = payload.apellidos;
            state.correoElectronico = payload.correoElectronico; 
            state.administrador = payload.administrador; 
            state.restablecerContrasena = payload.restablecerContrasena; 
            state.sistemaTurnos = payload.sistemaTurnos; 
            state.roles = payload.roles; 
        },
        logout: ( state ) => {     
            state.token = '';
            state.nombres = '';
            state.apellidos = '';
            state.correoElectronico = '';          
            state.administrador = false;          
            state.restablecerContrasena = false;                
            state.sistemaTurnos = 0;                
            state.roles = defaultRoles;          
        },
    },
})

export const { login, logout } = authSlice.actions

export default authSlice.reducer